import Box from '@mui/joy/Box'
import Typography from '@mui/joy/Typography'
import { useTranslation } from 'react-i18next'

import type { CheckoutSummaryProps } from '@/types/reservation-checkout'

export default function CheckoutEndTime({
    endsAtDateLabel,
    endsAtTimeLabel,
    minimumStay,
    desktop = false,
}: Pick<CheckoutSummaryProps, 'endsAtDateLabel' | 'endsAtTimeLabel' | 'minimumStay'> & { desktop?: boolean }) {
    const { t } = useTranslation()
    const dateChanged = minimumStay && minimumStay.requestedEndsAtDateLabel !== endsAtDateLabel
    const requestedDate = minimumStay?.requestedEndsAtDateLabel ?? endsAtDateLabel
    const requestedTime = minimumStay?.requestedEndsAtTimeLabel ?? endsAtTimeLabel

    if (desktop) {
        return (
            <>
                <Box sx={{
                    gridColumn: 3, gridRow: 1, maxWidth: '100%',
                }}>
                    <Typography level="body-sm" sx={{ fontWeight: 600, textTransform: 'uppercase', mb: 0.75 }}>
                        {t('checkout.orderSummary.end')}
                    </Typography>
                    <Typography level="body-md">
                        {dateChanged ? <s><b>{requestedDate}</b>, {requestedTime}</s> :
                            <><b>{requestedDate}</b>, {minimumStay ? <s>{requestedTime}</s> : requestedTime}</>}
                    </Typography>
                </Box>
                {minimumStay ? (
                    <Typography level="body-md" sx={{
                        gridColumn: 3, gridRow: 2, color: 'customGreen.dark',
                        textAlign: 'left',
                    }}>
                        <Box component="span" aria-hidden={dateChanged ? undefined : true} sx={{
                            visibility: dateChanged ? 'visible' : 'hidden',
                        }}><b>{endsAtDateLabel}</b>, </Box><span>{endsAtTimeLabel}</span>
                    </Typography>
                ) : null}
            </>
        )
    }

    return (
        <Box sx={{ position: 'relative', whiteSpace: 'nowrap', color: minimumStay ? 'customGreen.dark' : 'inherit' }}>
            {minimumStay ? (
                <Box component="s" sx={{
                    position: 'absolute', bottom: '100%', left: 0,
                    fontSize: '0.625rem', lineHeight: 1.25, color: 'neutral.600',
                }}>
                    {requestedDate}, {requestedTime}
                </Box>
            ) : null}
            <b>{endsAtDateLabel}</b>, {endsAtTimeLabel}
        </Box>
    )
}
